import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';
import { Slider } from '../shared/Slider';

interface InvestmentsFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
    maxInvestments: number;
}

export function InvestmentsFilter({ filters, onFiltersChange, maxInvestments }: InvestmentsFilterProps) {
    return (
        <FilterSection title="Minimum Number of Investments" defaultOpen={true}>
            <Slider
                min={0}
                max={maxInvestments}
                value={filters.numInvestmentsRange[0]}
                onChange={(value) => onFiltersChange({
                    ...filters,
                    numInvestmentsRange: [value, maxInvestments]
                })}
            />
        </FilterSection>
    );
} 